module.exports = __webpack_public_path__ + "static/media/template-import-product.82155f0f.csv";